import { MetricGroup, MetricsResponse, metricNumber } from "./useMetrics";

/**
 * Consultants ranked by Active Clients, busiest first; ties fall back to name
 * order so the ranking stays stable.
 */
export const rankConsultantGroups = (groups: MetricGroup[]): MetricGroup[] =>
  [...groups].sort(
    (a, b) =>
      metricNumber(b.metrics, "activeClients") -
        metricNumber(a.metrics, "activeClients") ||
      a.label.localeCompare(b.label),
  );

/**
 * A `groupBy=consultant` response shaped for the consultants x metrics table:
 * ranked columns, the two rows the table leaves out, and the resource-referral
 * row under the name consultants know it by. Shared by the Consultants tab and
 * the Data tab's Stats Report so the two tables cannot drift apart.
 */
export const shapeConsultantTable = (data: MetricsResponse): MetricsResponse => ({
  ...data,
  catalog: data.catalog
    .filter(
      (metric) => metric.id !== "initialContacts" && metric.id !== "b2b15min",
    )
    .map((metric) =>
      metric.id === "resourceReferrals"
        ? { ...metric, label: "Resource Partner Referral" }
        : metric,
    ),
  groups: rankConsultantGroups(data.groups),
});
